import { Component, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { debounceTime, map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { IShopifyProduct } from '@app/_shared/_models';
import { CollectionService } from '../../_services/collection.service';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-search',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, MatIconButton, MatSuffix, MatIcon, AsyncPipe]
})
export class SearchBarComponent implements OnInit, OnDestroy {
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly collectionService = inject(CollectionService);
  private readonly router = inject(Router);

  readonly searchInput = viewChild<any>('searchInput');
  readonly autocomplete = viewChild.required(MatAutocompleteTrigger);

  public searchForm!: UntypedFormGroup;
  public products$!: Observable<Array<IShopifyProduct>>;
  public products = new Array<IShopifyProduct>();
  public filteredProducts = new Observable<Array<IShopifyProduct>>();

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  ngOnInit(): void {
    this.products$ = this.collectionService.products$;
    this.searchForm = this.formBuilder.group({
      searchTerm: ['', Validators.maxLength(100)]
     });

    this.products$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((products: Array<IShopifyProduct>) => {
        products.forEach((product: IShopifyProduct) => {
          if (this.products?.findIndex(p => p.title === product.title) < 0) {
            this.products.push(product);
          }
        });
      });

    this.filteredProducts = this.searchForm.controls['searchTerm'].valueChanges
      .pipe(debounceTime(300))
      .pipe(
        startWith(''),
        map(value => this.filter(value))
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  // public onFocus(): void {
  //   this.collectionService.loadProducts('pool-category');
  //   this.collectionService.loadProducts('hot-tub-care-supplies');
  // }

  public async navigate(title: string): Promise<void> {
    const product = this.products.find(p => p.title === title);
    await this.router.navigate([`/products/${product?.handle}`]);
  }

  public async search(): Promise<void> {
    this.autocomplete().closePanel();
    this.searchInput().nativeElement.blur();

    await this.router.navigate(['/search'], { queryParams: { search: `${this.searchForm.controls['searchTerm'].value}`}});
  }

  private filter(value: string): Array<IShopifyProduct> {
    this.collectionService.searchProductsByKeyword(this.searchForm.controls['searchTerm'].value);
    const filterValue = value.toLowerCase();

    return this.products?.filter(p => p.title.toLowerCase().includes(filterValue));
  }

}
